var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { AssetsList } from "../store/types";
import { isProduction } from "../utils/env";
import { defaultAssetsHistoricalPriceData, defaultAssetsPriceData, ExternalAPIDataContext, } from "./externalAPIDataContext";
import { COINGECKO_AWS_BASE_URL, COINGECKO_CURRENCIES, } from "../constants/constants";
var getHistoricalAssetPricesInUSD = function (currencyName) { return __awaiter(void 0, void 0, void 0, function () {
    var apiURL, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiURL = "" + COINGECKO_AWS_BASE_URL + currencyName + "-historicalData";
                return [4 /*yield*/, axios.get(apiURL)];
            case 1:
                response = _a.sent();
                data = response.data;
                return [2 /*return*/, data];
        }
    });
}); };
var getLatestPrices = function () { return __awaiter(void 0, void 0, void 0, function () {
    var apiURL, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiURL = COINGECKO_AWS_BASE_URL + "latestPrices";
                return [4 /*yield*/, axios.get(apiURL)];
            case 1:
                response = _a.sent();
                data = response.data;
                return [2 /*return*/, data];
        }
    });
}); };
export var useFetchAssetsPrice = function (_a) {
    var _b = _a === void 0 ? { poll: true, pollingFrequency: 120000 } : _a, poll = _b.poll, pollingFrequency = _b.pollingFrequency;
    var _c = useState(defaultAssetsPriceData), data = _c[0], setData = _c[1];
    var _d = useState(defaultAssetsHistoricalPriceData), historicalData = _d[0], setHistoricalData = _d[1];
    var fetchAssetsPrices = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var assetsBarUSDC, latestPrices, todayTimestamp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    assetsBarUSDC = __spreadArray([], AssetsList).filter(function (asset) { return asset !== "USDC"; });
                    return [4 /*yield*/, getLatestPrices()];
                case 1:
                    latestPrices = _a.sent();
                    todayTimestamp = new Date(new Date().toDateString());
                    todayTimestamp.setHours(0 - todayTimestamp.getTimezoneOffset() / 60);
                    // Default USDC price
                    setData(function (prev) {
                        return __assign(__assign({}, prev), { USDC: {
                                loading: false,
                                latestPrice: 1,
                                dailyChange: 0,
                            } });
                    });
                    // Default USDC price for 3 years
                    setHistoricalData(function (prev) {
                        return __assign(__assign({}, prev), { USDC: {
                                loading: false,
                                history: Object.fromEntries(__spreadArray([], new Array(1095)).map(function (_, index) { return [
                                    todayTimestamp.valueOf() - index * (1000 * 60 * 60 * 24),
                                    1,
                                ]; })),
                            } });
                    });
                    // separately call latestPrices and historicalData
                    // because historicalData takes more time to load
                    assetsBarUSDC.forEach(function (asset) {
                        var coinId = COINGECKO_CURRENCIES[asset];
                        if (coinId) {
                            setData(function (prev) {
                                var _a;
                                return __assign(__assign({}, prev), (_a = {}, _a[asset] = {
                                    loading: false,
                                    latestPrice: coinId ? latestPrices[coinId].current_price : 0,
                                    dailyChange: coinId
                                        ? (latestPrices[coinId].price_change_24h /
                                            latestPrices[coinId].current_price) *
                                            100
                                        : 0,
                                }, _a));
                            });
                            getHistoricalAssetPricesInUSD(coinId)
                                .then(function (data) {
                                setHistoricalData(function (prev) {
                                    var _a;
                                    return __assign(__assign({}, prev), (_a = {}, _a[asset] = {
                                        loading: false,
                                        history: Object.fromEntries(data.map(function (item) { return [item.timestamp, item.price]; })),
                                    }, _a));
                                });
                            })
                                .catch(function (e) { return console.error(e); });
                        }
                    });
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        fetchAssetsPrices();
        var pollInterval = undefined;
        if (poll) {
            pollInterval = setInterval(fetchAssetsPrices, pollingFrequency);
        }
        return function () {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [fetchAssetsPrices, poll, pollingFrequency]);
    return {
        assetsPrice: { data: data },
        assetsHistoricalPrice: { data: historicalData },
    };
};
var useAssetPrice = function (_a) {
    var _b = _a === void 0 ? { asset: "WETH" } : _a, asset = _b.asset;
    var contextData = useContext(ExternalAPIDataContext);
    return {
        price: contextData.assetsPrice.data[asset].latestPrice,
        dailyChange: contextData.assetsPrice.data[asset].dailyChange,
        loading: contextData.assetsPrice.data[asset].loading,
    };
};
export default useAssetPrice;
export var useAssetsPrice = function () {
    var contextData = useContext(ExternalAPIDataContext);
    return {
        prices: Object.fromEntries(AssetsList.map(function (asset) { return [
            asset,
            {
                price: contextData.assetsPrice.data[asset].latestPrice,
                dailyChange: contextData.assetsPrice.data[asset].dailyChange,
                loading: contextData.assetsPrice.data[asset].loading,
            },
        ]; })),
    };
};
export var useAssetsPriceHistory = function () {
    var contextData = useContext(ExternalAPIDataContext);
    /**
     * Search the price of asset with a given date
     */
    var searchAssetPriceFromDate = useCallback(function (asset, date) {
        var queryDate = new Date(date.toDateString());
        queryDate.setUTCHours(0);
        return (contextData.assetsHistoricalPrice.data[asset].history[queryDate.valueOf()] || 0);
    }, [contextData.assetsHistoricalPrice.data]);
    /**
     * Wrapper for price search in the event where moment is provided
     */
    var searchAssetPriceFromMoment = useCallback(function (asset, momentObj) {
        return searchAssetPriceFromDate(asset, momentObj.toDate());
    }, [searchAssetPriceFromDate]);
    /**
     * Wrapper for price search in the event where timestamp is provided
     */
    var searchAssetPriceFromTimestamp = useCallback(function (asset, timestamp) {
        return searchAssetPriceFromDate(asset, new Date(timestamp));
    }, [searchAssetPriceFromDate]);
    return {
        histories: Object.fromEntries(AssetsList.map(function (asset) { return [
            asset,
            {
                loading: contextData.assetsPrice.data[asset].loading,
                history: contextData.assetsHistoricalPrice.data[asset].history,
            },
        ]; })),
        searchAssetPriceFromDate: searchAssetPriceFromDate,
        searchAssetPriceFromMoment: searchAssetPriceFromMoment,
        searchAssetPriceFromTimestamp: searchAssetPriceFromTimestamp,
    };
};
// circulating supply of RBN
export var useAssetInfo = function (asset) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(), info = _b[0], setInfo = _b[1];
    var fetchAssetInfo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiURL, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (info) {
                        return [2 /*return*/];
                    }
                    apiURL = COINGECKO_AWS_BASE_URL + "circulatingSupply";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    return [4 /*yield*/, axios.get(apiURL)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    setInfo({
                        circulating_supply: data,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    !isProduction() && console.log("Asset info fetch error:", error_1); // eslint-disable-line
                    setInfo({
                        circulating_supply: 0,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [info]);
    useEffect(function () {
        fetchAssetInfo();
    }, [fetchAssetInfo]);
    return {
        info: info || { circulating_supply: 0 },
        loading: loading,
    };
};
//# sourceMappingURL=useAssetPrice.js.map